import {
  OptionValue,
  isOptionValue
} from "./chunk-7ORKFJEB.mjs";
import {
  OptionDivider,
  isDivider
} from "./chunk-6R75I2LH.mjs";
import {
  OptionLabel,
  isLabelOption
} from "./chunk-PKSELPD4.mjs";
import {
  OptionReactNode,
  isOptionReactNode
} from "./chunk-ZWRC5TA7.mjs";
import {
  ChevronDown
} from "./chunk-5VDSC7QK.mjs";

// src/dropdown-menu/src/dropdown-menu.tsx
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import { v4 as uuid } from "uuid";
import { cx } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
var REQUIRES_LOCALISATION_BUTTON_LABEL = "Actions";
var baseClasses = "group/trigger focus:outline-none focus:ring-2 focus:ring-interactive-focus rounded";
var DropdownMenuTrigger = () => /* @__PURE__ */ jsxs(
  RadixDropdownMenu.Trigger,
  {
    className: cx(
      "col-auto flex w-min gap-2 border border-surface-border bg-surface-light px-4 py-3 text-base-strong hover:bg-surface-subtle data-[state=open]:bg-surface-subtle",
      baseClasses
    ),
    children: [
      REQUIRES_LOCALISATION_BUTTON_LABEL,
      /* @__PURE__ */ jsx("span", { className: "group-data-[state=open]/trigger:rotate-180", children: /* @__PURE__ */ jsx(ChevronDown, {}) })
    ]
  }
);
var DropdownMenu = ({
  items,
  trigger,
  align = "start",
  compact = false,
  onOpenChange,
  triggerAriaLabel
}) => /* @__PURE__ */ jsx("div", { className: "w-min", children: /* @__PURE__ */ jsxs(RadixDropdownMenu.Root, { onOpenChange, children: [
  Boolean(trigger) ? /* @__PURE__ */ jsx(
    RadixDropdownMenu.Trigger,
    {
      "aria-label": triggerAriaLabel,
      className: baseClasses,
      children: trigger
    }
  ) : /* @__PURE__ */ jsx(DropdownMenuTrigger, {}),
  /* @__PURE__ */ jsx(RadixDropdownMenu.Portal, { children: /* @__PURE__ */ jsx(
    RadixDropdownMenu.Content,
    {
      align,
      className: cx(
        "z-30 grid min-w-[160px] rounded border border-surface-strong bg-surface-light shadow-[0px_2px_4px_0px_rgba(119,_144,_181,_0.25)]",
        { "gap-2  p-2": !compact, "px-1 py-2": compact }
      ),
      side: "bottom",
      sideOffset: 4,
      children: items.map((item) => {
        if (isDivider(item)) {
          return /* @__PURE__ */ jsx(OptionDivider, { compact }, uuid());
        } else if (isLabelOption(item)) {
          return /* @__PURE__ */ createElement(OptionLabel, { compact, ...item, key: uuid() });
        } else if (isOptionValue(item)) {
          return /* @__PURE__ */ jsx(OptionValue, { ...item }, uuid());
        } else if (isOptionReactNode(item)) {
          return /* @__PURE__ */ createElement(OptionReactNode, { ...item, key: uuid() });
        }
        return null;
      })
    }
  ) })
] }) });

export {
  DropdownMenu
};
